import {crearHash} from "../Funciones/crearHash";

export const adap_crear_mov = (entidad, consecutivo) => {

    let obj = {
        tipo: entidad.tipo,
        idUsuario: entidad.idUsuario,
        codigoUsuario: entidad.codigo,
        fecha: new Date().getTime(),
        consecutivo: consecutivo,
        nombre: entidad.nombre,
        valor: entidad.valor,
        moneda: entidad.tipo === 'Puntos' ? entidad.tipo : 'USD',
        departamento: 'Adminstracion',
        correo: entidad.correo,
        visible: 'Visible',
        detalle: entidad.detalle,
        idContrato: entidad.idContrato ? entidad.idContrato : '',
    }

    let hasString = JSON.stringify(obj)
    obj.hashString = hasString
    obj.hash = crearHash({text: hasString})

    return obj


}